import { getLenisInstance } from 'shared/lenis';

export const goTo = (target, options) => {
  const lenis = getLenisInstance();
  if (!lenis) return;
  lenis.scrollTo(`#${target}`, { immediate: true, duration: 0, ...options });
};
